export default class UserLevel {
  constructor (levelData) {
    this.id = levelData.id
    this.name = levelData.name
    this.code = levelData.code
  }
}
